import RouteApp from './RouteApp.mapper';

export default RouteApp;
